import React from 'react';
import { createContainer } from 'unstated-next';

const useConsole = () => {
    const [logs, setLogs] = React.useState<(string | number)[]>([]);

    const appendToLogs = (log: string | number) => {
        setLogs((logs) => [log, ...logs]);
    };
    return { logs, appendToLogs };
};

export const Console = createContainer(useConsole);

